import React from 'react'
import { Link } from "react-router-dom";

function Header(){
    return (
     <>
    

    <header className="main_header_area">
              
        <div className="header_menu bg-theme" id="header_menu">
            <nav className="navbar navbar-default">
                <div className="container">
                    <div className="navbar-flex d-flex align-items-center justify-content-between w-100 pb-1 pt-1">
                        
                        <div className="navbar-header logo">
                            <Link to="/" className="navbar-brand" >
                                <img src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} alt="Logo" />
                            </Link>
                        </div>
                       
                        <div className="navbar-collapse1 d-flex align-items-center" id="bs-example-navbar-collapse-1">
                            <ul className="nav navbar-nav" id="responsive-menu">
                                <li><Link to="/" >Home </Link></li>
                                <li><Link to="/hotels" >Hotels </Link></li>
                                <li><Link to="/holiday-packages" >Holiday Packages </Link></li>
                                <li><Link to="/hajj-umrah" >Hajj & Umrah </Link></li>
                                <li><Link to="/top-destinations" >Top Destinations </Link></li>
                            </ul>
                        </div>
                        <div className="d-flex align-items-center">
                            <a href="#" className="headerCallBtn">Call Now</a>
                        </div>

                        {/*<div id="slicknav-mobile"></div>*/}
                    </div>
                </div>
            </nav>
        </div>
        
    </header>
    <div className="tet"></div>
    </>
    )
}

export default Header;
